import type { Feature } from './features.config';
import { FEATURES_SWITCH } from './features.config';

const isFeatureEnable = (feature: Feature) => FEATURES_SWITCH[feature];

export { isFeatureEnable };
